import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { IItem } from '@coreui/angular-pro'
import { GenericResponse, PortalUsers } from 'src/app/interfaces/apiresponses'; 
import { RestService } from 'src/app/services/rest/rest.service';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-admin-maker',
  templateUrl: './admin-maker.component.html',
  styleUrls: ['./admin-maker.component.scss']
})
export class AdminMakerComponent implements OnInit {
  bShowUserDetailsScreen : boolean = false
  selectedItem: any
  portalUserName: string = ''
  bViewOnly: boolean = true
  bUserActive: boolean = false
  bUserRejected: boolean = false
  bNewUser: boolean = false
  
  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state
    
    switch (event.data.action){
      case 1:
        this.saveUser()
        break
      case 2:
        this.resetPassword()
        break
      case 3:
        this.deactivateUser()
        break
      case 4:
        this.activateUser()
        break
      default:
        break
    }
  }

  closeAlert(event: any){
    this.bAlert = event.state
    
    switch (event.data.action){
      case 1:
        break
      case 2:
        break
      case 3:
        break
      case 4:
        break
      default:
        break
    }
  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }


  constructor(private restApi: RestService, private changeDetector: ChangeDetectorRef){

  }

  ngOnInit() {
    this.getAllPortalUsers()
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  columns = [
    {
      key: 'name',
      label: 'Name',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'emailId',
      label: 'Email ID',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'mobileNumber',
      label: 'Mobile',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'portalRoleName',
      label: 'Role',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'isApproved',
      label: 'Status',
      _cellProps: {align: 'middle'},
      filter: false
    }
  ];

  // User form
  userform!: FormGroup
  bUndefined!: boolean
  userNameValid!: boolean
  userEmailValid!: boolean
  userMobileValid!: boolean
  userRoleValid!: boolean

  get UserName() {return this.userform.get('userName')}
  get UserEmail() {return this.userform.get('userEmail')}
  get UserMobile() {return this.userform.get('userMobile')}
  get UserRole() {return this.userform.get('userRole')}

  isUserNameValid(){
    let returnVal = ''
    
    if (this.UserName?.invalid && (this.UserName?.dirty || this.UserName?.touched || !this.bNewUser))
    {
      this.userNameValid = false
      if (this.UserName?.errors?.['required'])
        returnVal =  'Name is required'
      else if (this.UserName?.errors?.['minlength'])
        returnVal = 'Name must be at least 2 characters long'
      else if (this.UserName?.errors?.['pattern'])
        returnVal = 'Only one space between words'
      else if (!this.UserName?.errors?.['maxLength'])
        returnVal = 'Name must be at least 60 characters long'
      else
        returnVal = 'Please enter a valid name'
    } else {
      var reg = new RegExp('^[a-zA-Z ]*$')
      if (!reg.test(this.UserName?.value)){
        returnVal = 'You should only use alphabets (a to z)'
        this.userNameValid = false
      } else {
        returnVal = ''

        if (this.UserName?.dirty || this.UserName?.touched)
        {
          this.userNameValid = true
        }
      }      
    }

    return returnVal
  }

  isUserEmailValid(){
    let returnVal = ''

    if (this.UserEmail?.invalid && (this.UserEmail?.dirty || this.UserEmail?.touched || !this.bNewUser))
    {
      this.userEmailValid = false
      if (this.UserEmail?.errors?.['required'])
        returnVal =  'Email is required'
      else if (this.UserEmail?.errors?.['pattern'])
        returnVal = 'Please enter a valid email ID'
      else
        returnVal = 'Please enter a valid email ID'
    } else {
      returnVal = ''
      if (this.UserEmail?.dirty || this.UserEmail?.touched)
      {
        this.userEmailValid = true
      }
    }
    
    return returnVal
  }
  isuserRoleValid(){
    let returnVal = ''

    if (this.UserRole?.invalid && (this.UserRole?.dirty || this.UserRole?.touched || !this.bNewUser))
    {
      this.userRoleValid = false
      if (this.UserRole?.errors?.['required'])
        returnVal =  'Role is required'

    } else {
      returnVal = ''
      if (this.UserRole?.dirty || this.UserRole?.touched)
      {
        this.userRoleValid = true
      }
    }
    
    return returnVal
  }

  isUserMobileValid(){
    //console.log(this.UserMobile?.dirty, this.UserMobile?.value.indexOf('-') > -1, this.UserMobile?.value.substr(0,1) !== '+')
    let returnVal = ''

    if (this.UserMobile?.invalid && (this.UserMobile?.dirty || this.UserMobile?.touched || !this.bNewUser))
    {
      this.userMobileValid = false
      if (this.UserMobile?.errors?.['required'])
        returnVal =  'Mobile number is required'
      else if (this.UserMobile?.value.substr(0,1) !== '+' && this.UserMobile?.dirty) {
        returnVal = 'Mobile number must start with + and country code'
        this.userMobileValid = false
      }
      else if (this.UserMobile?.errors?.['pattern'])
        returnVal = 'Please enter a Number(0-9)'
      else if (this.UserMobile?.value.indexOf('-') > -1 && this.UserMobile?.dirty){
          console.log("why",this.UserMobile?.value.indexOf('-') > -1)
          returnVal =  'Mobile numbers not contain (-)'
          this.userMobileValid = false
        }
      // else if (this.UserMobile?.errors?.['minlength'])
      //   returnVal =  'Mobile numbers must be 13 digits or more'
      
      else if (!this.UserMobile?.errors?.['maxLength'])
        returnVal = 'Mobile no must be at least 20 characters long'
      else
        returnVal = 'Please enter a valid mobile number(+9999999999999)'
    } else {
      if (this.UserMobile?.value.substr(0,1) !== '+' && this.UserMobile?.dirty) {
        returnVal = 'Mobile number must start with + and country code'
        this.userMobileValid = false
      } 
      else {
        returnVal = ''
        if (this.UserMobile?.dirty || this.UserMobile?.touched)
        {
          this.userMobileValid = true
        }
      }
    }
    
    return returnVal
  }

  usersData: IItem[] = []
  selectedItems = [2, 3];

  getAllPortalUsers(){
    this.restApi.getAllPortalUsers().subscribe({
      next: (v: PortalUsers) => {
        if (v.success){
          this.usersData = v.dhabiPortalUsers.map((item, userId) => {
              const _selected = this.selectedItems.includes(userId);
              return {
                ...item,
                _selected
              };
            })
        }
      },
      error: (e) => {

      }
    })
  }

  getUserStatus(item: any) {
    if (!item.isDecisionTaken)
      return "Decision Pending"
    else if (item.isApproved && item.isActive)
      return "Active"
    else if (!item.isApproved)
      return "Rejected"
    else if (!item.isActive)
      return "Inactive"
    else
      return "Unknown"
  }

  getStatusBadge(item: any) {
    if (!item.isDecisionTaken)
      return "warning"
    else if (item.isApproved && item.isActive)
      return "success"
    else if (!item.isApproved)
      return "danger"
    else if (!item.isActive)
      return "warning"
    else
      return "warning"
  }

  rowSelected = (clickedItem: any) => {
    this.bShowUserDetailsScreen = true
    this.bViewOnly = true
    this.selectedItem = clickedItem.item

    this.userNameValid = this.bUndefined
    this.userEmailValid = this.bUndefined
    this.userMobileValid = this.bUndefined
    this.userRoleValid = this.bUndefined

    console.log(this.selectedItem)

    this.portalUserName = this.selectedItem.name
    this.bUserActive = this.selectedItem.isActive
    this.bUserRejected = !this.selectedItem.isApproved

    // Fix for null mobile number
    if (this.selectedItem.mobileNumber == undefined || this.selectedItem.mobileNumber == null)
      this.selectedItem.mobileNumber = ""

      this.userform = new FormGroup({
        userName: new FormControl(this.selectedItem?.name, [Validators.required, Validators.minLength(2), Validators.pattern(/^((?!\s{2,}).)*$/),Validators.maxLength(60)]),
        userEmail: new FormControl(this.selectedItem?.emailId, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
        userMobile: new FormControl(this.selectedItem?.mobileNumber, [Validators.required, Validators.minLength(0),Validators.maxLength(20),  Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')]),
        userRole: new FormControl(this.selectedItem?.portalRoleName, [Validators.required])
      })

    this.userform.disable()
  }

  goBackToSearchScreen(){
    this.bShowUserDetailsScreen = false
    this.bNewUser = false
    this.getAllPortalUsers()
  }

  deactivateUserPrompt(){
    this.showAlertBox('Confirm', 'Are you sure you want to DEACTIVATE this Portal User?', 'No', true, 'Yes', {action: 3, matrixId: 0})
  }

  deactivateUser(){
    this.restApi.deactivatePortalUser(this.UserEmail?.value, true).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.goBackToSearchScreen()
        } else {
          this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
        }
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
      }
    })
  }

  activateUserPrompt(){
    this.showAlertBox('Confirm', 'Are you sure you want to ACTIVATE this Portal User?', 'No', true, 'Yes', {action: 4, matrixId: 0})
  }

  activateUser(){
    this.restApi.deactivatePortalUser(this.UserEmail?.value, false).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.goBackToSearchScreen()
        } else {
          this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
        }
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
      }
    })
  }

  resetPasswordPrompt(){
    this.showAlertBox('Confirm', 'Are you sure you want to reset the password of this Portal User?', 'No', true, 'Yes', {action: 2, matrixId: 0})
  }

  resetPassword(){
    this.restApi.resetPortalUserPassword(this.UserEmail?.value).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.goBackToSearchScreen()
        } else {
          this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
        }
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
      }
    })
  }

  enableEdit(){
    this.bViewOnly = false
    this.userform.enable()
    this.UserEmail?.disable()
  }

  saveUserPrompt(){
    if (!this.userform.valid) {
      this.showAlertBox('Sorry', 'Please make sure that you have entered everything correctly and then try to save')
      return
    }

    this.showAlertBox('Confirm', 'Are you sure you want to save the details?', 'No', true, 'Yes', {action: 1, matrixId: 0})
  }

  getRoleIdFromRole(){
    if (this.UserRole?.value == 'Super Admin')
      return 1
    else if (this.UserRole?.value == 'Company Admin')
      return 2
    else if (this.UserRole?.value == 'Customer Creator')
      return 3
    else if (this.UserRole?.value == 'Customer Approver')
      return 4
    else if (this.UserRole?.value == 'Retail Admin')
      return 5
    else if (this.UserRole?.value == 'Support')
      return 6
    else if (this.UserRole?.value == 'Super Admin Checker')
      return 7
     else if (this.UserRole?.value == 'Compliance')
      return 8
    else
      return 9

  }

  saveUser(){
    if (!this.bNewUser){
      this.restApi.updatePortalUser(this.UserName?.value, this.UserEmail?.value, this.UserMobile?.value, this.getRoleIdFromRole()).subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.goBackToSearchScreen()
          } else {
            this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
        }
      })
    } else {
      this.restApi.createPortalUser(this.UserName?.value, this.UserEmail?.value, this.UserMobile?.value, this.getRoleIdFromRole()).subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.goBackToSearchScreen()
          } else {
            this.showAlertBox('Sorry', v.message)
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There are some technical issues. Please contact support.')
        }
      })
    }
  }

  resetForm(){
    this.UserName?.setValue('')
    this.UserMobile?.setValue('')
    this.UserEmail?.setValue('')
    this.UserRole?.setValue('')
  }

  enableCreateCustomerForm(){
    this.bNewUser = true
    this.bViewOnly = false

    this.selectedItem = []
    this.selectedItem.name = ''
    this.selectedItem.emailId = ''
    this.selectedItem.mobileNumber = ''
    this.selectedItem.portalRoleName = ''

    this.userform = new FormGroup({
      userName: new FormControl(this.selectedItem?.name, [Validators.required, Validators.minLength(2), Validators.pattern(/^((?!\s{2,}).)*$/), Validators.maxLength(60)]),
      userEmail: new FormControl(this.selectedItem?.emailId, [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      userMobile: new FormControl(this.selectedItem?.mobileNumber, [Validators.required, Validators.minLength(0),Validators.maxLength(20),  Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')]),
      userRole: new FormControl(this.selectedItem?.portalRoleName, [Validators.required])
    })

    this.userNameValid = this.bUndefined
    this.userEmailValid = this.bUndefined
    this.userMobileValid = this.bUndefined
    this.userRoleValid = this.bUndefined

    this.bShowUserDetailsScreen = true
  }
}
